import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DateFilterTypes } from '../../enums/date-filter.enum';

@Component({
  selector: 'app-date-filter',
  standalone: true,
  imports: [TranslateModule, CommonModule],
  templateUrl: './date-filter.component.html',
  styleUrl: './date-filter.component.scss',
})
export class DateFilterComponent {
  @Output() close = new EventEmitter<any>();
  isDateFilterOpen = false;
  public selectedOption: string | undefined = 'Last 24h';

  toggleDateFilter(option?: string) {
    if (option) {
      this.selectedOption =
        this.dateRangeTypesDictionary.find((item) => item === option) ||
        this.selectedOption;
      this.close.emit(option);
    }
    this.isDateFilterOpen = !this.isDateFilterOpen;
  }

  dateRangeTypesTranslations: { [key in DateFilterTypes]: string } = {
    [DateFilterTypes.Last24h]: 'LAST24h',
    [DateFilterTypes.Last7Days]: 'LAST7DAYS',
    [DateFilterTypes.Last30Days]: 'LAST30DAYS',
  };

  dateRangeTypesDictionary: string[] = Object.keys(DateFilterTypes)
    .filter((key) => isNaN(Number(key)))
    .map(
      (key) =>
        this.dateRangeTypesTranslations[
          DateFilterTypes[key as keyof typeof DateFilterTypes]
        ],
    );
}
